// Pure context definition file (no React components) so that the
// AuthProvider module stays "component-only" and React Fast Refresh
// works reliably without invalidating the whole app on every edit.
import { createContext } from 'react';
import type { User, Session } from '@supabase/supabase-js';
import type { Profile } from '@/lib/supabaseClient';
import type { SubscriptionStatus } from '@/services/stripeService';

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  profile: Profile | null;
  isLoading: boolean;
  subscriptionStatus: SubscriptionStatus | null;
  refreshSubscription: () => Promise<void>;
  signInWithEmail: (email: string, password: string) => Promise<{ error: any }>;
  signUpWithEmail: (
    email: string,
    password: string,
    fullName: string,
    userType: 'funcionario' | 'opositor',
    municipalityName?: string,
    autonomousCommunity?: string,
    opositorBody?: string,
    sessionId?: string,
  ) => Promise<{ error: any }>;
  signInWithGoogle: () => Promise<{ error: any }>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
